import { render, staticRenderFns } from "./SettlementPaymentFormModal.vue?vue&type=template&id=1c5ef1b2&scoped=true"
import script from "./SettlementPaymentFormModal.vue?vue&type=script&lang=js"
export * from "./SettlementPaymentFormModal.vue?vue&type=script&lang=js"
import style0 from "./SettlementPaymentFormModal.vue?vue&type=style&index=0&id=1c5ef1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ef1b2",
  null
  
)

export default component.exports